import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import {
  Autocomplete,
  Box,
  Button,
  colors,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import useApi from "_api/index";
import { useFormik } from "formik";
import RenderFieldsCustomers from "components/Car/RenderFieldsCustomers";
import RenderDetailCar from "components/Car/RenderDetailCar";
import Dropzone from "components/Dropzone_one";
import { NavigateBefore } from "@mui/icons-material";
import { GradientButton } from "components/GradientButton";
import * as Yup from "yup";
import ChipCustomize from "components/Chip";
import { PaymentChannelOptions } from "contants/options";
import AlertToast from "components/AlertToast";

const ModalSellCar = ({ id, open, onClose, onSaved = () => {} }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [details, setDetails] = React.useState(null);
  const [customerImage, setCustomerImage] = React.useState([]);
  const [files, setFiles] = React.useState([]);
  const [error, setError] = React.useState(null);
  const [toast, setToast] = React.useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    if (id && open) {
      fetchData();
    }
  }, [id, open]);

  // start websocket
  //let intendPresent_flag = true;
  const [intendPresentFlag, setIntendPresentFlag] = React.useState(true);
  let wSocket = null;

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const autoReadOptions = {
    autoRead: true,
    idNumberRead: true,
    idTextRead: true,
    idPhotoRead: true,
  };

  const setAutoReadOptions = () => {
    const JS_OBJ = {
      Command: "SetAutoReadOptions",
      AutoRead: autoReadOptions.autoRead,
      IDNumberRead: autoReadOptions.idNumberRead,
      IDTextRead: autoReadOptions.idTextRead,
      IDATextRead: true,
      IDPhotoRead: autoReadOptions.idPhotoRead,
    };
    wSocketSend(JSON.stringify(JS_OBJ));

    // const cmdNIDAutoRead = document.getElementById("chkAutoRead").checked;
    // const cmdIDNumber = document.getElementById("chkAutoNIDNumber").checked;
    // const cmdText = document.getElementById("chkAutoNIDText").checked;
    // const cmdphoto = document.getElementById("chkAutoNIDPhoto").checked;
    // const JS_OBJ = {
    //   Command: "SetAutoReadOptions",
    //   AutoRead: cmdNIDAutoRead,
    //   IDNumberRead: cmdIDNumber,
    //   IDTextRead: cmdText,
    //   IDATextRead: true,
    //   IDPhotoRead: true,
    // };
    // var jsonStr = JSON.stringify(JS_OBJ);
    // wSocketSend(jsonStr);
  };

  const wSocketSend = (jsonStr) => {
    // console.log("wSocketSend jsonStr > ", jsonStr);
    wSocket.send(jsonStr);
  };

  const clearScreen = () => {
    console.log("call clearScreen");
    //setTimeout(() => {
    formik.resetForm();
    setCustomerImage([]);
    //}, 1000);
    //setTimeout(() => {
    // document.getElementById("prefix").value = "";
    // document.getElementById("fullName").value = "";
    // document.getElementById("idCardNumber").value = "";
    // document.getElementById("phoneNumber").value = "";
    // document.getElementById("address").value = "";
    // document.getElementById("nationality").value = "";
    //}, 2000);
    // document.getElementById("phoneNumber").value = "";
  };

  const putToScreen = async (jsObj) => {
    console.log("jsObj > ", jsObj);
    try {
      let prefix = "";
      let fullName = "";
      let address = "";
      const IDNum = jsObj.ID_Number;
      const IDText = jsObj.ID_Text;
      const IDPhoto = jsObj.ID_Photo;
      const status = jsObj.Status;
      if (status == 0) {
        if (IDText != "") {
          const NIDData = IDText.split("#");
          const prefix_T = NIDData[1];
          const firstName_T = NIDData[2];
          const lastName_T = NIDData[4];
          prefix = prefix_T;
          fullName = firstName_T + " " + lastName_T;
          address =
            NIDData[9] +
            " " +
            NIDData[10] +
            " " +
            NIDData[11] +
            " " +
            NIDData[12] +
            " " +
            NIDData[13] +
            "\r\n" +
            NIDData[14] +
            " " +
            NIDData[15] +
            " " +
            NIDData[16];
        }
      }
      // 2. อัปเดต Formik values พร้อมกัน
      await Promise.all([
        formik.setFieldValue("prefix", prefix),
        formik.setFieldValue("idCardNumber", IDNum),
        formik.setFieldValue("fullName", fullName),
        formik.setFieldValue("address", address),
      ]);
      // await formik.setValues({
      //   ...formik.values,
      //   idCardNumber: IDNum,
      //   fullName: fullName,
      //   address: address,
      //   isFromCard: true
      // }, false); // false = ไม่ต้อง validate

      // 3. อัปเดต touched หลังจาก values ถูกตั้งค่า
      formik.setTouched({
        ...formik.touched,
        idCardNumber: true,
        fullName: true,
        address: true,
      });

      // 4. ตรวจสอบ validation ใหม่
      setTimeout(() => {
        formik.validateForm();
      }, 50);

      // 5. อัปเดตรูปภาพ (ถ้ามี)
      if (IDPhoto != null) {
        const photoUrl = `data:image/jpeg;base64,${IDPhoto}`;
        const fileName = `id_card_${Date.now()}.jpg`;
        const idCardFile = dataURLtoFile(photoUrl, fileName);
        const nidCardFile = {
          file: idCardFile,
          url: photoUrl,
          name: fileName,
          status: "complete",
          isFromCard: true,
        };
        setCustomerImage([nidCardFile]);
      }
    } catch (error) {
      console.error("Error in putToScreen:", error);
    }
  };

  const onGetMessage = (jsonString) => {
    const msgObj = JSON.parse(jsonString);
    if (msgObj.Message == "AgentStatusE") {
      if (msgObj.Status == 1) {
        setAutoReadOptions();
      } else {
        alert("ERROR Code :" + msgObj.Status);
      }
    }

    if (msgObj.Message == "CardStatusChangeE") {
      if (msgObj.Status == -1004) {
        alert("ERROR Code :" + msgObj.Status);
        return;
      } else if (msgObj.Status == 1) {
        clearScreen();
        setIntendPresentFlag(false);
      } else if (msgObj.Status == -16) {
        setIntendPresentFlag(true);
        clearScreen();
      } else if (msgObj.Status == 0) {
        alert("Card Status: Unknown");
        clearScreen();
      } else {
        alert("ERROR Code :" + msgObj.Status);
      }
    }

    if (msgObj.Message == "ReadingProgressE") {
    }

    if (msgObj.Message == "AutoReadIDCardE") {
      putToScreen(msgObj);
    }

    if (msgObj.Message == "AutoSelectReaderE") {
    }
  };
  useEffect(() => {
    if (open) {
      wSocket = new WebSocket("ws://localhost:14820/TDKWAgent");
      wSocket.onopen = () => {
        console.log("WebSocket opened");
      };

      wSocket.onmessage = function (evt) {
        onGetMessage(evt.data);
      };

      wSocket.onerror = (error) => {
        console.log("WebSocket: error", error);
      };

      return () => {
        wSocket.close();
        console.log("WebSocket closed");
      };
    }
  }, [open]);
  // end websocket

  const fetchData = async () => {
    setIsLoading(true);
    // Function to fetch data related to the car with the given id
    // This can be implemented as needed
    await useApi.ready_car
      .getReadySellCarById(id)
      .then((response) => {
        console.log("Fetched car details for selling:", response);
        if (response.success) {
          // Handle the response data as needed
          const { car } = response.data;
          setDetails(response.data || {});
          if (response.data.car) {
            formik.setFieldValue(
              "sell_price",
              car.sell_price ?? car.car_price ?? 0
            );
            formik.setFieldValue(
              "resale_product_percentage",
              car.sell_price ?? car.car_price ?? 0
            );
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching car details for selling:", error);
      })
      .finally(() => {
        setIsLoading(false);
        // Any final actions after fetching data
      });
  };

  const generateInitialValues = () => {
    return {
      // ข้อมูลลูกค้า
      fullName: "",
      idCardNumber: "",
      phoneNumber: "",
      address: "",
      prefix: "",
      nationality: "ไทย",

      // ข้อมูลการขาย
      sell_price: 0, // ราคาขาย
      amount: 1, // จำนวน
      market_channel: "", // ช่องทางการขาย
      payment_channel: "", // ช่องทางการชำระเงิน
      resale_product_percentage: 0, // รวมจำนวนเงินทั้งสิ้น & ราคาหลังหักส่วนลด
      change_product_percentage: 0, // ส่วนลดพิเศษ
      special_discount: 0, // คิดเป็นเงิน
    };
  };

  const generateValidationSchema = () => {
    return Yup.object().shape({
      // customer
      prefix: Yup.string().required("กรุณาเลือกคำนำหน้า"),
      fullName: Yup.string().required("กรุณากรอกชื่อ-นามสกุล"),
      idCardNumber: Yup.string().when("nationality", {
        is: (val) => val === "ไทย",
        then: (schema) =>
          schema
            .required("กรุณากรอกเลขบัตรประชาชน")
            .matches(/^\d+$/, "เลขบัตรประชาชนต้องเป็นตัวเลขเท่านั้น")
            .length(13, "เลขบัตรประชาชนต้องมี 13 หลัก"),
        otherwise: (schema) =>
          schema
            .required("กรุณากรอกเลขหนังสือเดินทาง (Passport No.)")
            .matches(
              /^[A-Za-z0-9]+$/,
              "เลขหนังสือเดินทางต้องเป็นตัวอักษรหรือตัวเลขเท่านั้น"
            )
            .min(6, "เลขหนังสือเดินทางต้องมีอย่างน้อย 6 หลัก")
            .max(20, "เลขหนังสือเดินทางกรอกได้มากสุด 20 หลัก"),
      }),
      phoneNumber: Yup.string()
        .required("กรุณากรอกเบอร์โทรศัพท์")
        .matches(/^[0-9]+$/, "กรุณากรอกตัวเลขเท่านั้น")
        .min(9, "เบอร์โทรศัพท์ต้องมีอย่างน้อย 9 หลัก"),
      address: Yup.string().required("กรุณากรอกที่อยู่"),
      nationality: Yup.string().required("กรุณากรอกสัญชาติ"),

      // car
      sell_price: Yup.number()
        .required("กรุณากรอกราคาขาย")
        .min(1, "ราคาขายต้องมากกว่า 0")
        .nullable(),
      market_channel: Yup.string().required("กรุณาเลือกช่องทางการขาย"),
      payment_channel: Yup.string().required("กรุณาเลือกช่องทางการชำระเงิน"),
    });
  };

  const formik = useFormik({
    initialValues: generateInitialValues(),
    validationSchema: generateValidationSchema(), // Define your validation schema if needed
    onSubmit: (values) => {
      console.log("Form values on submit:", values);
      handleCreateSellCar(values);
    },
  });

  const handleCreateSellCar = async (values) => {
    setIsLoading(true);
    const formatData = {
      // ข้อมูลลูกค้า
      ...values,
      id_image: customerImage,
      // ข้อมูลการขาย
      car_id: id || "",
      slip: files?.map((file) => file.file) || [],
    };

    try {
      const respone = await useApi.ready_car.createOrderSellCar(formatData);
      if (respone.isStatus) {
        // Call the onSaved callback if provided
        onSaved();
        // Reset form values if needed
        formik.resetForm();
        // Close the dialog
        onClose();
      } else {
        throw new Error(respone.message || "Failed to submit form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      // setError("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
      setToast({
        open: true,
        message: "เกิดข้อผิดพลาดในการบันทึกข้อมูล",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    onClose();
    setDetails(null);
    formik.resetForm({ values: generateInitialValues() });
    setCustomerImage([]);
    setFiles([]);
    setError(null);
  };

  if (!details) {
    return null; // หรือแสดงข้อความว่าไม่มีข้อมูล
  }

  return (
    <Dialog
      open={open}
      // onClose={handleClose}
      onClose={(event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          handleClose();
        }
      }}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          padding: 2,
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle id="modal-title">
        <Typography variant="h4">ขายรถ</Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          padding: 2,
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: 8,
            height: 8,
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: colors.grey[300],
            borderRadius: 4,
          },
        }}
      >
        <form onSubmit={formik.handleSubmit}>
          <input
            type="checkbox"
            class="form-check-input mx-3"
            id="chkAutoRead"
            onclick="setAutoReadOptions();"
            checked="checked"
            style={{ display: "none" }}
          ></input>
          <input
            type="checkbox"
            class="form-check-input"
            id="chkAutoNIDNumber"
            onclick="setAutoReadOptions();"
            checked="checked"
            style={{ display: "none" }}
          ></input>
          <input
            type="checkbox"
            class="form-check-input"
            id="chkAutoNIDText"
            checked="checked"
            onclick="setAutoReadOptions();"
            style={{ display: "none" }}
          ></input>
          <input
            type="checkbox"
            class="form-check-input"
            id="chkAutoNIDPhoto"
            checked="checked"
            onclick="setAutoReadOptions();"
            style={{ display: "none" }}
          ></input>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <RenderFieldsCustomers
              formik={formik}
              setCustomerImage={(files) => {
                setCustomerImage(files);
                formik.setFieldValue("id_image", files);
              }}
              images={customerImage}
            />
            <RenderDetailCar car={details?.car} />

            <Box sx={{ mt: 1 }}>
              <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                <Typography variant="h5" sx={{ mb: 1 }}>
                  รายละเอียดการขายรถ
                </Typography>

                {details?.car?.car_product_type === "consignment_car" && (
                  <ChipCustomize label="รถฝากขาย" status="consignment" />
                )}
              </Box>
              <Box
                sx={{
                  p: 2,
                  mx: 6,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12}>
                    <Grid container alignItems="center">
                      <Grid item xs={12} sm={3}>
                        <Typography variant="body1">ช่องการชำระ</Typography>
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        <Autocomplete
                          fullWidth
                          options={PaymentChannelOptions}
                          getOptionLabel={(option) => option.label}
                          onChange={(event, value) =>
                            formik.setFieldValue("payment_channel", value.id)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="ช่องทางการชำระเงิน"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  bgcolor: "white",
                                  height: "40px",
                                },
                              }}
                              error={
                                formik.touched.payment_channel &&
                                Boolean(formik.errors.payment_channel)
                              }
                              helperText={
                                formik.touched.payment_channel &&
                                formik.errors.payment_channel
                                  ? formik.errors.payment_channel
                                  : ""
                              }
                              onBlur={formik.handleBlur}
                            />
                          )}
                          value={
                            PaymentChannelOptions.find(
                              (option) =>
                                option.id === formik.values.payment_channel
                            ) || null
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <Grid container>
                      <Grid item xs={12} sm={3}>
                        <Typography variant="body1">หลักฐานการชำระ</Typography>
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        {error && (
                          <Typography
                            variant="body2"
                            color="error"
                            sx={{ mt: 1 }}
                          >
                            {error}
                          </Typography>
                        )}
                        <Dropzone
                          files={files}
                          setFiles={(newFiles) => {
                            setFiles(newFiles);
                          }}
                          maxFiles={1}
                          setError={setError}
                          onDelete={(file) => {
                            setFiles((prevFiles) =>
                              prevFiles.filter((f) => f !== file)
                            );
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <Grid container alignItems="center">
                      <Grid item xs={12} sm={3}>
                        <Typography variant="body1">ช่องทางการขาย</Typography>
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        <Autocomplete
                          fullWidth
                          options={["Marketplace", "หน้าร้าน"]}
                          getOptionLabel={(option) => option}
                          onChange={(event, value) =>
                            formik.setFieldValue("market_channel", value)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="ช่องทางการขาย"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  bgcolor: "white",
                                  height: "40px",
                                },
                              }}
                              error={
                                formik.touched.market_channel &&
                                Boolean(formik.errors.market_channel)
                              }
                              helperText={
                                formik.touched.market_channel &&
                                formik.errors.market_channel
                                  ? formik.errors.market_channel
                                  : ""
                              }
                              onBlur={formik.handleBlur}
                            />
                          )}
                          value={formik.values.market_channel || ""}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <Grid container alignItems="center">
                      <Grid item xs={12} sm={3}>
                        <Typography variant="body1">ราคาขาย</Typography>
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          type="number"
                          name="sell_price"
                          placeholder="0"
                          disabled={
                            details?.car?.car_product_type === "consignment_car"
                          }
                          value={formik.values.sell_price || ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            formik.setFieldValue("sell_price", value);

                            // คำนวณราคาหลังหักส่วนลด
                            const discountPercentage =
                              parseFloat(
                                formik.values.change_product_percentage
                              ) || 0;
                            const discountAmount =
                              (discountPercentage / 100) * value;
                            formik.setFieldValue(
                              "special_discount",
                              discountAmount
                            );

                            // คำนวณราคาหลังหักส่วนลด
                            const resalePrice = value - discountAmount;
                            formik.setFieldValue(
                              "resale_product_percentage",
                              resalePrice
                            );

                            // คำนวณรวมจำนวนเงินทั้งสิ้น
                            const totalAmount =
                              resalePrice * (formik.values.amount || 1);
                            formik.setFieldValue(
                              "resale_product_percentage",
                              totalAmount
                            );
                          }}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.sell_price &&
                            Boolean(formik.errors.sell_price)
                          }
                          helperText={
                            formik.touched.sell_price &&
                            formik.errors.sell_price
                              ? formik.errors.sell_price
                              : ""
                          }
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              bgcolor: "white",
                              height: "40px",
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <Grid container alignItems="center">
                      <Grid item xs={12} sm={3}>
                        <Typography variant="body1">ส่วนลดพิเศษ</Typography>
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        <Grid container spacing={1} alignItems="center">
                          <Grid item xs={2}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              type="number"
                              name="change_product_percentage"
                              placeholder="0"
                              value={
                                formik.values.change_product_percentage || ""
                              }
                              onChange={(e) => {
                                const value = e.target.value;
                                formik.setFieldValue(
                                  "change_product_percentage",
                                  value
                                );
                                // คำนวณส่วนลดพิเศษเป็นเงิน
                                const sellPrice =
                                  parseFloat(formik.values.sell_price) || 0;
                                const discount =
                                  (parseFloat(value) / 100) * sellPrice;
                                formik.setFieldValue(
                                  "special_discount",
                                  discount
                                );

                                // คำนวณราคาหลังหักส่วนลด
                                const resalePrice = sellPrice - discount;
                                formik.setFieldValue(
                                  "resale_product_percentage",
                                  resalePrice
                                );

                                // คำนวณรวมจำนวนเงินทั้งสิ้น
                                const totalAmount =
                                  resalePrice * (formik.values.amount || 1);
                                formik.setFieldValue(
                                  "resale_product_percentage",
                                  totalAmount
                                );
                              }}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.change_product_percentage &&
                                Boolean(formik.errors.change_product_percentage)
                              }
                              helperText={
                                formik.touched.change_product_percentage &&
                                formik.errors.change_product_percentage
                                  ? formik.errors.change_product_percentage
                                  : ""
                              }
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  bgcolor: "white",
                                  height: "40px",
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <Typography variant="body1">%</Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography variant="body1">คิดเป็นเงิน</Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              type="number"
                              name="special_discount"
                              placeholder="0"
                              value={formik.values.special_discount || ""}
                              error={
                                formik.touched.special_discount &&
                                Boolean(formik.errors.special_discount)
                              }
                              helperText={
                                formik.touched.special_discount &&
                                formik.errors.special_discount
                                  ? formik.errors.special_discount
                                  : ""
                              }
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  bgcolor: "white",
                                  height: "40px",
                                },
                              }}
                              InputProps={{
                                readOnly: true, // ทำให้ไม่สามารถแก้ไขได้
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <Grid container alignItems="center">
                      <Grid item xs={12} sm={3}>
                        <Typography variant="body1">
                          ราคาหลังหักส่วนลด
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          type="number"
                          name="resale_product_percentage"
                          placeholder="0"
                          value={formik.values.resale_product_percentage || ""}
                          error={
                            formik.touched.resale_product_percentage &&
                            Boolean(formik.errors.resale_product_percentage)
                          }
                          helperText={
                            formik.touched.resale_product_percentage &&
                            formik.errors.resale_product_percentage
                              ? formik.errors.resale_product_percentage
                              : ""
                          }
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              bgcolor: "white",
                              height: "40px",
                            },
                          }}
                          InputProps={{
                            readOnly: true, // ทำให้ไม่สามารถแก้ไขได้
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <Grid container alignItems="center">
                      <Grid item xs={12} sm={3}>
                        <Typography variant="body1">
                          รวมจำนวนเงินทั้งสิ้น
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          type="number"
                          name="resale_product_percentage"
                          placeholder="0"
                          value={formik.values.resale_product_percentage || ""}
                          error={
                            formik.touched.resale_product_percentage &&
                            Boolean(formik.errors.resale_product_percentage)
                          }
                          helperText={
                            formik.touched.resale_product_percentage &&
                            formik.errors.resale_product_percentage
                              ? formik.errors.resale_product_percentage
                              : ""
                          }
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              bgcolor: "white",
                              height: "40px",
                            },
                          }}
                          InputProps={{
                            readOnly: true, // ทำให้ไม่สามารถแก้ไขได้
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        </form>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "space-between",
          borderTop: `1px solid ${colors.grey[300]}`,
        }}
      >
        <Button
          variant="outlined"
          onClick={handleClose}
          disabled={isLoading}
          sx={{
            borderRadius: 2,
            width: "auto",
            borderColor: colors.grey[400],
            color: colors.grey[400],
            "&:hover": {
              borderColor: colors.grey[400],
              color: colors.grey[400],
              borderWidth: 2,
              bgcolor: "transparent",
            },
          }}
        >
          <NavigateBefore
            sx={{
              width: 30,
              height: 30,
            }}
          />
        </Button>

        <GradientButton
          onClick={formik.handleSubmit}
          sx={{
            width: "auto",
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          type="submit"
          disabled={isLoading}
          loading={isLoading}
        >
          <Typography sx={{ fontSize: "16px" }}>บันทึก</Typography>
        </GradientButton>
      </DialogActions>

      <AlertToast
        open={toast.open}
        message={toast.message}
        type={toast.severity}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
      />
    </Dialog>
  );
};

export default ModalSellCar;
